export const scrollTo = elementId => {
  setTimeout(() => {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({behavior: 'smooth'});
      }
    }, 10);
}